@if (isSelectionTable()) {
<div class="row actions">
  @if (visible) {
  <div class="col-1 btn-group">
    @if (isGroupDetails()) {
    <button
      class="btn btn-outline-danger btn-sm"
      (click)="ungroupCandidate()"
      matTooltip="Retirer les candidats du groupe">
      <span class="material-symbols-outlined pt-1"> group_remove </span>
    </button>
    } @if (!isGroupDetails()) {
    <button class="btn btn-outline-primary btn-sm" (click)="addCandidatesToGroup()">
      <span class="material-symbols-outlined pt-1"> group_add </span>
    </button>
    }
    <button
      [disabled]="selectedCandidates.length === 0"
      class="btn btn-outline-primary align-items-center btn-sm"
      (click)="sendEmailRemindCandidates()"
      [ngClass]="{ 'disabled-button': selectedCandidates.length === 0 }"
      matTooltip="Relancer les candidats sélectionnés">
      <span class="material-symbols-outlined pt-1">mail</span>
    </button>
    @if (canDeleteCandidate()) {
    <button
      class="btn btn-outline-danger btn-sm"
      (click)="deleteCandidate()"
      matTooltip="Supprimer les candidats sélectionnés">
      <span class="material-symbols-outlined pt-1"> delete </span>
    </button>
    }
  </div>
  }
</div>
}
<div class="filter-container">
  <label for="advancementFilter">Filtrer par avancement :</label>
  <select #advancement id="advancementFilter" class="form-select" (change)="filterByAdvancement(advancement.value)">
    <option value="">Tous</option>
    <option value="En cours">En cours</option>
    <option value="Terminé">Terminé</option>
    <option value="Non commencé">Non commencé</option>
  </select>
</div>

@if (filteredCandidates.length === 0) {
<div class="text-center mt-3">
  <p>Pas de candidats pour ce filtre</p>
</div>
} @if (filteredCandidates.length > 0) {
<div class="table-responsive mt-2" [ngClass]="!isSelectionTable() ? 'mt-3' : ''">
  <table class="table table-hover table-bordered hide-scrollbar" aria-label="candidates-selection-table">
    <thead>
      <tr>
        @if (isSelectionTable()) {
        <th class="align-middle" style="width: 3%">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="allIsSelected"
            [indeterminate]="selectedCandidates.length !== 0 && !allIsSelected" />
        </th>
        }
        <th class="align-middle" scope="col">
          <div class="row">
            <strong class="col-1">Candidat</strong>
          </div>
        </th>
        <th class="align-middle" scope="col">
          <div class="row">
            <strong class="col-1">Email</strong>
          </div>
        </th>
        <th class="align-middle" scope="col">
          <strong>Avancement</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (candidate of filteredCandidates; track candidate) {
      <tr class="table-row" (click)="boxChecked(candidate)">
        @if (isSelectionTable()) {
        <td>
          <mat-checkbox
            (change)="boxChecked(candidate)"
            [checked]="selectedCandidates.includes(candidate)"
            (click)="$event.stopPropagation()" />
        </td>
        }
        <td>{{ candidate.firstName }} {{ candidate.lastName.toUpperCase() }}</td>
        <td>
          {{ candidate.email }}
        </td>
        <td [matTooltip]="candidateAdvancementToolTipText(candidate)">
          {{ candidate.advancement }}
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
}
